import React, { useContext, useEffect, useState } from "react";
import Sidenavigation from "../layouts/Sidenavigation";
import Topnavigation from "../layouts/Topnavigation";
import Quickbar from "../layouts/Quickbar";
import AuthContext from "../../context/auth-context";

export const Salesstudentsreport = () => {
  const ctx = useContext(AuthContext);
  const authPermission = localStorage.getItem("PermissionDetails");

  const [studentHide, setHideStudent] = useState(true);
  const [mStudentHide, setHideMStudent] = useState(true);
      
  useEffect(() => {
    JSON.parse(authPermission).forEach(function (loca) {
      if (
        loca.access_level.access_level == "ADMIN"
        ) {
          setHideStudent(false);
        }
    
      if (
          loca.access_level.access_level == "SUPER_ADMIN"
        ) {
          setHideMStudent(false);
        }
    });
  }, [authPermission]);

  return (
    <div
      className={
        ctx.darkMode
          ? "ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar ms-dark-theme"
          : "ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar"
      }
    >
      <Sidenavigation />
      <main className="body-content">
        <Topnavigation />
        <div
          hidden={mStudentHide}
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginTop: 50
          }}
        >
          <iframe
            src="https://lookerstudio.google.com/embed/reporting/c0d3b992-a67a-4b31-9ac4-3a2202b663ea/page/p_ir987cngfd"
            style={{
              width: '98%',
              height: '1200px',
              border: 'none'
            }}
            title="Embedded Page"
            sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-downloads"
            allowFullScreen
          />
        </div>
        <div
          hidden={studentHide}
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginTop: 50
          }}
        >
          <iframe
            src="https://lookerstudio.google.com/embed/reporting/5a3912c0-d41d-46d5-8303-28bbfa6f1707/page/p_x7hbrsdhqd"
            style={{
              width: '98%',
              height: '1200px',
              border: 'none'
            }}
            title="Embedded Page"
            sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-downloads"
            allowFullScreen
          />
        </div>
      </main>
      <Quickbar />
    </div>
  );
};

export default Salesstudentsreport;
